import { React, PropTypes, Routes, Route } from '../lib/imports';

import { getPageById } from '../lib/utils';

const getPage = (id) => {
  const Component = getPageById(id);
  return <Component />;
};

const Content = ({ allRoutes, routeBase, defaultPage, quizDisabled, routeFilter }) => {
  return (
    <Routes>
      <Route key={defaultPage.id} path='/' pageId={defaultPage.id} element={getPage(defaultPage.id)} isHome end />
      {allRoutes.filter(routeFilter).map(({ id, ...routeProps }) => (
        <Route key={id} pageId={id} element={getPage(id)} isAuthenticated={quizDisabled} {...routeProps} />
      ))}
    </Routes>
  );
};

Content.propTypes = {
  allRoutes: PropTypes.array,
  defaultPage: PropTypes.object,
  quizDisabled: PropTypes.bool,
  routeFilter: PropTypes.func,
};

export default Content;
